var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8406 45.4069C20.8406 46.8103 19.7256 47.9394 18.3397 47.9394H10.8369C5.31197 47.9394 0.833252 43.4041 0.833252 37.8095V10.7965C0.833252 5.20185 5.31197 0.666626 10.8369 0.666626H18.3397C19.7256 0.666626 20.8406 1.79991 20.8406 3.19909C20.8406 4.59723 19.7256 5.73156 18.3397 5.73156H10.8369C8.08591 5.73156 5.83508 8.01078 5.83508 10.7965V37.8095C5.83508 40.5952 8.08591 42.8744 10.8369 42.8744H18.3397C19.7256 42.8744 20.8406 44.0035 20.8406 45.4069ZM53.5088 22.5725L40.2644 8.22182C39.3167 7.19955 37.7343 7.15396 36.7308 8.11303C35.7246 9.06925 35.6762 10.6719 36.6233 11.6912L45.8914 21.7705H19.9132C18.621 21.7705 17.506 22.9101 17.506 24.303C17.506 25.6958 18.6262 26.8355 19.9132 26.8355H45.7976L36.4275 36.9189C35.4799 37.9378 35.5288 39.54 36.535 40.4971C37.1174 40.954 37.7322 41.1861 38.2532 41.1861C38.9175 41.1861 39.5818 40.919 40.0737 40.3882L53.3181 26.0375C54.4154 25.0627 54.4154 23.5432 53.5088 22.5725Z",
    fill: "#FF3541"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.095c73164d95f6454b89afc4cc9f27e0.svg";
export { ForwardRef as ReactComponent };